import Reveal, { SectionHead } from "./Reveal";

const IMG = "https://images.unsplash.com/photo-1751838024459-3637aee16ee2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxzdGVlcGxlcyUyMGNyb3NzJTIwY2h1cmNoJTIwYXJjaGl0ZWN0dXJhbCUyMGRhcmslMjBtaWRuaWdodCUyMGJsdWUlMjBnb2xkfGVufDB8fHx8MTc4OTA1Mzk3NXww&ixlib=rb-4.1.0&q=85";

export default function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="py-20 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-surface/40">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <SectionHead eyebrow="The Problem" title="Sunday Is Not the Only Day People Need Ministry." />
          <Reveal delay={0.1}>
            <div className="mt-8 space-y-3 text-sm sm:text-base text-slate-300 leading-relaxed">
              <p>Your church may have powerful preaching. Your worship may be authentic. Your people may carry love, wisdom, testimony, and prayer.</p>
              <p>But if your ministry disappears online from Monday through Saturday, your message is absent from the very places people turn when they need help.</p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <blockquote className="mt-10 border-l-2 border-gold pl-6" data-testid="problem-pull-quote">
              <p className="font-cormorant italic text-xl sm:text-2xl text-amber-100/90 leading-snug">
                “The question is not: should the church be on social media? The question is — when someone
                in your city needs God at midnight, will they be able to find your church?”
              </p>
            </blockquote>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="relative">
          <div className="absolute -inset-3 border border-gold/30 translate-x-4 translate-y-4 pointer-events-none" />
          <img src={IMG} alt="Church steeple against a midnight sky"
            className="relative w-full h-[26rem] lg:h-[32rem] object-cover grayscale-[35%] contrast-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-transparent to-transparent" />
        </Reveal>
      </div>

      <div className="max-w-7xl mx-auto mt-16 lg:mt-24" data-testid="problem-stats">
        <Reveal>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="rounded-lg border-t-2 border-[#0D2E63] bg-white/60 backdrop-blur-sm p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(13,46,99,0.12)]">
              <p className="font-display text-4xl sm:text-5xl text-[#0D2E63]">49% → 31%</p>
              <p className="mt-4 text-sm text-[#31456B] leading-relaxed">
                Regular church attendance has dropped from 49% pre-pandemic to roughly 31% (Barna) — and about a
                third of Millennials now <em>often</em> replace physical church attendance with digital spiritual content.
              </p>
            </div>
            <div className="rounded-lg border-t-2 border-[#3B1B5E] bg-white/60 backdrop-blur-sm p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(59,27,94,0.12)]">
              <p className="font-display text-4xl sm:text-5xl text-[#3B1B5E]">70%</p>
              <p className="mt-4 text-sm text-[#31456B] leading-relaxed">
                of people now engage with a church online before ever visiting in person — about 25 million Americans
                attend church online. Churches without a real social presence are effectively invisible to two-thirds
                of their potential community.
              </p>
            </div>
            <div className="rounded-lg border-t-2 border-[#0B5D43] bg-white/60 backdrop-blur-sm p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(11,93,67,0.12)]">
              <p className="font-display text-4xl sm:text-5xl text-[#0B5D43]">89%</p>
              <p className="mt-4 text-sm text-[#31456B] leading-relaxed">
                of churches have some digital presence — but most are minimal and poorly maintained. The recurring
                complaint in church media circles: <em>“dedicated volunteers, but no training.”</em>
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
